export const environment = {
    production: false,
    url: 'https://dev.jayteewashington.com',
    apiUrl: 'https://devapi.jayteewashington.com/v1',
    apiKey: 'XOTzqCM6Yg1e3qycpN998agfTHRd2EgQ9dDhjeOr',
    siteKey: '6LflaDIrAAAAAD8Y5uFz_HFO1mLZwDAAfxNjWjma',
    resumeUrl: '/assets/docs/JibrantWashingtonResume.pdf'
};
